import React from 'react';
import '../App.css';
import logowritten from '../assets/images/eventle_transparan.png';
import appStoreBadge from '../assets/images/app_store.webp';
import googlePlayBadge from '../assets/images/google-play.webp';
import OpenAppButton from './OpenAppButton';

function NotFound() {
  return (
    <div style={{
      minHeight: '100vh',
      backgroundColor: 'black',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      padding: '20px',
      textAlign: 'center',
      color: 'white',
      fontFamily: 'Arial, sans-serif'
    }}>
      {/* 404 Message */}
      <div style={{ marginBottom: '40px' }}>
        <p style={{
          fontSize: '1.1rem',
          color: '#ccc',
          maxWidth: '500px',
          lineHeight: '1.6'
        }}>
          Eventle uygulamasını indirerek tüm etkinlikleri keşfedin!
        </p>
      </div>

      {/* App Store Badges */}
      <div style={{
        display: 'flex',
        gap: '20px',
        marginBottom: '30px',
        flexWrap: 'wrap',
        justifyContent: 'center'
      }}>
        <a 
          href="https://apps.apple.com/tr/app/eventle/id6474272088?l=tr" 
          target="_blank" 
          rel="noopener noreferrer"
          style={{ textDecoration: 'none' }}
        >
          <img 
            src={appStoreBadge} 
            alt="Download on the App Store" 
            style={{
              width: '150px',
              height: 'auto'
            }}
          />
        </a>
        <a 
          href="https://play.google.com/store/apps/details?id=com.eventle.eventle&hl=tr" 
          target="_blank" 
          rel="noopener noreferrer"
          style={{ textDecoration: 'none' }}
        >
          <img 
            src={googlePlayBadge} 
            alt="Get it on Google Play" 
            style={{
              width: '150px',
              height: 'auto'
            }}
          />
        </a>
      </div>

      {/* Open App Button */}
      { /iPad|iPhone|iPod/.test(navigator.userAgent) && /Instagram/i.test(navigator.userAgent) && (
        <p style={{ color: "#aaa", marginTop: 10, maxWidth: 420 }}>
          Instagram içinde otomatik açılma sınırlandırılmıştır. “Uygulamada Aç”a dokunun
          ya da sayfayı Safari’de açarsanız uygulama anında açılır.
        </p>
      )}


      {/* Back to Home Link */}
      <div>
        <a 
          href="/" 
          style={{
            color: '#6535F3',
            textDecoration: 'none',
            fontSize: '1rem',
            border: '1px solid #6535F3',
            padding: '10px 20px',
            borderRadius: '25px',
            transition: 'all 0.3s ease'
          }}
          onMouseOver={(e) => {
            e.target.style.backgroundColor = '#6535F3';
            e.target.style.color = 'white';
          }}
          onMouseOut={(e) => {
            e.target.style.backgroundColor = 'transparent';
            e.target.style.color = '#6535F3';
          }}
        >
          Ana Sayfaya Dön
        </a>
      </div>

    </div>
  );
}

export default NotFound; 